import React from 'react';
import { Ghost } from 'lucide-react';
export const TopBar = () => {
  return <div className="bg-base-black border-b border-halloween-orange-border py-2 px-4 text-xs font-barlow tracking-wider flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-0 z-50 relative" data-id="element-1460" data-mp="232wzxtyst6xa">
      {/* Halloween sale — the headline promo */}
      <div className="flex items-center gap-2 text-halloween-orange font-bold order-1 sm:order-none" data-id="element-1461" data-mp="1t6af356h2fv9">
        <Ghost size={14} strokeWidth={2} className="shrink-0" data-id="element-1462" data-mp="2qry6tcrzga0g" />
        <span className="uppercase" data-id="element-1463" data-mp="2lt4wtubwn151">
          Halloween Sale — 60% Off + Free Shipping
        </span>
        <span className="w-1.5 h-1.5 rounded-full bg-halloween-orange animate-pulse shrink-0" data-id="element-1464" data-mp="2h1wol1mb9ltg"></span>
      </div>

      <div className="items-center space-x-4 text-text-dimmed hidden md:flex" data-id="element-1465" data-mp="2c2sco38059zf">
        <span className="text-white" data-id="element-1466" data-mp="39j8y3v1meosv">LIMITED HALLOWEEN STOCK</span>
        <span data-id="element-1467" data-mp="34s92qu85gesh">|</span>
        <span data-id="element-1468" data-mp="34rqvl2jy8g5s">FREE SHIPPING ON ALL ORDERS IN THE USA</span>
        <span data-id="element-1469" data-mp="34q63rkp0rbbm">|</span>
        <span className="flex items-center text-acid-green" data-id="element-1470" data-mp="257rtw2lwpbn">
          <span className="w-2 h-2 rounded-full bg-acid-green animate-pulse mr-2" data-id="element-1471" data-mp="2614fdo8y91p"></span>
          UNITS DEPLOYING NOW
        </span>
      </div>
    </div>;
};